


























































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import RujukanHivSvc from "@/services/RujukanHivService";
import { appModule } from "@/store/modules/app";
import { RujukanHivInterface } from "@/types/rujukan_hiv";

@Component({
  inject: {
    isReadOnly: { default: () => () => false },
  },
})
export default class RujukanHivKonfirmasiModal extends Vue {
  @Prop() readonly value!: boolean;
  @Prop({ default: null }) rujukan!: RujukanHivInterface | null;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  saving = false;
  requiredRule = [(v: any) => !!v || "*Kolom ini harus diisi"];

  form = this.defaultForm();

  defaultForm() {
    return {
      konfirmasi_status: null as "diterima" | "ditolak" | null,
      konfirmasi_nama_pasien: "",
      konfirmasi_no_register_penerima: "",
      konfirmasi_umur: null as number | null,
      konfirmasi_jenis_kelamin: null as "L" | "P" | null,
      konfirmasi_tgl_melapor: "",
      konfirmasi_nama_unit_penerima: "",
      konfirmasi_diisi_oleh: "",
    };
  }

  get dialog() {
    return this.value;
  }

  set dialog(val: boolean) {
    this.$emit("input", val);
  }

  @Watch("value")
  onDialogOpen(val: boolean) {
    if (!val || !this.rujukan) return;

    const r = this.rujukan;
    this.form = {
      konfirmasi_status:
        r.konfirmasi_status !== "belum" ? r.konfirmasi_status : null,
      konfirmasi_nama_pasien: r.konfirmasi_nama_pasien || r.nama_pasien || "",
      konfirmasi_no_register_penerima: r.konfirmasi_no_register_penerima || "",
      konfirmasi_umur: r.konfirmasi_umur,
      konfirmasi_jenis_kelamin: r.konfirmasi_jenis_kelamin,
      konfirmasi_tgl_melapor: r.konfirmasi_tgl_melapor || "",
      konfirmasi_nama_unit_penerima: r.konfirmasi_nama_unit_penerima || "",
      konfirmasi_diisi_oleh: r.konfirmasi_diisi_oleh || "",
    };
  }

  async save() {
    if (this.readOnly) return;
    const form = this.$refs.form as any;
    if (!form.validate()) return;
    if (this.saving || !this.rujukan) return;

    this.saving = true;
    try {
      const resp = await RujukanHivSvc.updateKonfirmasi(this.rujukan.id, this.form);
      if (resp.data.status == "1") {
        appModule.NoticeDelay(resp.data.message || "Konfirmasi tersimpan");
        this.$emit("saved");
        this.dialog = false;
      }
    } finally {
      this.saving = false;
    }
  }

  close() {
    this.dialog = false;
  }
}
